var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "calender_svg__b",
    width: "107.8%",
    height: "108.9%",
    x: "-3.9%",
    y: "-4.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "calender_svg__d",
    width: "101.7%",
    height: "107.6%",
    x: "-.9%",
    y: "-3.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "calender_svg__a",
    d: "M182 191h1180c5.523 0 10 4.477 10 10v1020c0 5.523-4.477 10-10 10H182c-5.523 0-10-4.477-10-10V201c0-5.523 4.477-10 10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calender_svg__e",
    d: "M0 5c0-2.762 2.233-5 4.995-5h1100.01A5.003 5.003 0 011110 5v241c0 2.762-2.233 5-4.995 5H4.995A5.003 5.003 0 010 246V5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1100 -414)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M0 0h1545v3046H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "calender_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#calender_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#calender_svg__b)",
    xlinkHref: "#calender_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#calender_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#calender_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(232 271)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#calender_svg__d)",
    xlinkHref: "#calender_svg__e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#calender_svg__e"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#calender_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1106 419h13a2 2 0 012 2v10a2 2 0 01-2 2h-13a2 2 0 01-2-2v-10a2 2 0 012-2zm-2 5.5h17m-12.5-7.5v5m8-5v5",
    stroke: "#008CFF"
  })))));
}
export default SvgCalender;